const ALLOWED_AVATAR_MIME_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/gif', 'image/avif'] as const
const ALLOWED_AVATAR_EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'avif'] as const
const BLOCKED_AVATAR_EXTENSIONS = ['svg', 'svgz'] as const

export const AVATAR_FILE_ACCEPT = ALLOWED_AVATAR_MIME_TYPES.join(',')

function getFileExtension(fileName: string): string | null {
  const trimmedFileName = fileName.trim()
  const lastDotIndex = trimmedFileName.lastIndexOf('.')
  if (lastDotIndex <= 0 || lastDotIndex === trimmedFileName.length - 1) return null

  const ext = trimmedFileName.slice(lastDotIndex + 1).trim().toLowerCase()
  return ext || null
}

function extensionFromMimeType(mimeType: string | null | undefined): string | null {
  const normalizedMime = (mimeType || '').toLowerCase()
  switch (normalizedMime) {
    case 'image/png':
      return 'png'
    case 'image/jpeg':
      return 'jpg'
    case 'image/webp':
      return 'webp'
    case 'image/gif':
      return 'gif'
    case 'image/avif':
      return 'avif'
    default:
      return null
  }
}

export function isSvgAvatarFile(fileName: string, mimeType: string | null | undefined): boolean {
  const normalizedMime = (mimeType || '').toLowerCase()
  const ext = getFileExtension(fileName)
  return normalizedMime === 'image/svg+xml' || !!ext && BLOCKED_AVATAR_EXTENSIONS.includes(ext as typeof BLOCKED_AVATAR_EXTENSIONS[number])
}

export function isAllowedAvatarFile(fileName: string, mimeType: string | null | undefined): boolean {
  if (isSvgAvatarFile(fileName, mimeType)) return false

  const normalizedMime = (mimeType || '').toLowerCase()
  const ext = getFileExtension(fileName)
  const isAllowedMime = ALLOWED_AVATAR_MIME_TYPES.includes(normalizedMime as typeof ALLOWED_AVATAR_MIME_TYPES[number])
  const isAllowedExt = !!ext && ALLOWED_AVATAR_EXTENSIONS.includes(ext as typeof ALLOWED_AVATAR_EXTENSIONS[number])

  if (isAllowedMime && isAllowedExt) return true
  if (isAllowedMime && !ext) return true
  return false
}

export function getAllowedAvatarExtension(fileName: string, mimeType: string | null | undefined): string | null {
  const ext = getFileExtension(fileName)
  if (ext && ALLOWED_AVATAR_EXTENSIONS.includes(ext as typeof ALLOWED_AVATAR_EXTENSIONS[number])) {
    return ext === 'jpeg' ? 'jpg' : ext
  }

  return extensionFromMimeType(mimeType)
}
